<mat-list role="list">
  <h2 *ngIf="showVariableName" class="mat-title" [class.rds-c-variable-information-has-decorators]="hasDecorators">
    {{ variable?.name }}
    <rds-c-variable-information-decorators
      *ngIf="hasDecorators"
      [measure]="variable?.isMeasure"
      [required]="variable?.isRequired"
      [weight]="variable?.isWeight"
    >
    </rds-c-variable-information-decorators>
  </h2>

  <ng-container *ngFor="let property of $any(variable) | keyvalue | filterEmpty : _iconMap">
    <ng-container [ngSwitch]="property.key">
      <ng-container *ngSwitchCase="'validValues'">
        <mat-list-item class="mtna-wrappable-list-item" role="listitem">
          <mat-icon mat-list-icon>{{_iconMap[property.key]}}</mat-icon>
          <h3 mat-line>{{ _labelMap[property.key] }}</h3>
          <p mat-line class="wrap-line valid-value-text">
            <mtna-valid-values
              *ngIf="variable && variable.validValues"
              [readonly]="true"
              [validValues]="variable.validValues"
            ></mtna-valid-values>
          </p>
        </mat-list-item>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <mat-list-item class="mtna-wrappable-list-item" role="listitem">
          <mat-icon mat-list-icon>{{_iconMap[property.key]}}</mat-icon>
          <h3 mat-line>{{ _labelMap[property.key] }}</h3>
          <p mat-line class="wrap-line" [innerHTML]="property.value"></p>
        </mat-list-item>
      </ng-container>
    </ng-container>
  </ng-container>
</mat-list>
